export default {
      id: "meal2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#meal2",
      toString: function () {
        return this.url;
      }
    }